export default __webpack_public_path__ + "static/media/louisville_header.26b880c7.jpg";